import OrdersSection from "./OrdersSection/index";

export default OrdersSection;